import React from 'react';
import { Progress } from 'semantic-ui-react';

interface IHeaderProps {
  headerLogo: string;
  stepNumber: string | number;
  totalSteps: string | number;
  heading: string;
  subHeading: string;
  extraWording?: string | number;
}

const Header = (props: IHeaderProps): React.ReactElement => {
  return (
    <div>
      <div className="header-image-container">
        <div className="image-container">
          <img src={props?.headerLogo} alt="logo" />
        </div>

        <span className="step-number">{`Step ${props?.stepNumber} ${
          props?.extraWording || ''
        }`}</span>
        <Progress value={props?.stepNumber} total={props?.totalSteps} size="tiny" />
      </div>
      <div className="header-text-container">
        <h1 className="heading-text">{props?.heading}</h1>
        <span className="heading-description">{props?.subHeading}</span>
      </div>
    </div>
  );
};

export default Header;
